import {post, get} from '../axios/index';

export const getDictionaries = params => post('/api/Main/Dictionaries', params); // 字典获取

export const upload = params => post('/api/Main/Upload', params); // 上传

export const orderReady = params => post('/api/Main/OrderReady', params); // 准备出运
export const ordering = params => post('/api/Main/Order', params); // 下单
export const orderDetail = params => post('/api/Main/OrderDetail', params); // 出运详情

export const getTempDictionaries = params => post('/api/Main/TempDictionaries', params); // 字典获取

export const getMemberSearchRecords = params => post('/api/Main/membersearchrecords', params); // 字典获取

export const getUserInstructions = params => post('/api/main/index', params); // 获取用户须知





// WEBPACK FOOTER //
// ./src/api/app.js